/**
 * Матрицы поставщиков — русские лейблы из предметной области.
 *
 * Единый источник истины: раньше эти массивы были размазаны по 10+ местам
 * с разным составом (некоторые забывали обновиться при изменении).
 * При добавлении/переименовании матрицы правь только здесь.
 */

/** Все 5 матриц в канонической последовательности (от «ближних» к «дальним»). */
export const MATRIX_LABELS = ['Склад', 'Китай', 'РФ', 'Производители', 'Стоки'] as const
export type MatrixLabel = (typeof MATRIX_LABELS)[number]

// Prisma where-фильтры ожидают mutable string[], поэтому массивы ниже — не
// readonly. Для UI-логики достаточно обычной типизации.

/** Матрицы очереди закупки — их видит/обрабатывает PROCUREMENT. */
export const PROCUREMENT_MATRICES: MatrixLabel[] = ['Китай', 'Производители']

/** Матрицы менеджера — цены в них правит только MANAGER/ADMIN. */
export const MANAGER_MATRICES: MatrixLabel[] = ['Склад', 'РФ', 'Стоки']
